import SearchPhysicianModel from "./SearchPhysicianModel";

export default class ActivateUser {
    constructor(model: SearchPhysicianModel, email: string) {
        this.lastName = model.lastName;
        this.ssn4 = model.ssn4;
        this.dateOfBirth = model.dateOfBirth;
        this.email = email;
    }

    lastName: string;
    ssn4: string;
    dateOfBirth: string;
    email: string;
    clientId: string;
    registerClientId: string;
}